export default __webpack_public_path__ + "static/media/fp-grey.a3b49f3e.svg";